import { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useNavigate, useOutletContext } from "react-router-dom";
// helpers
import { appSection, hotelPanelRootUrl, pagesUrl } from "../../common/utils/panel-helpers/helpers";
// components
import FormMessage from "../../components/FormMessage";
import SectionLoader from "../../components/SectionLoader";
// @ts-ignore
import { CustomButton } from "@gl-shared/shared/ui";
// @ts-ignore
import { CustomTable } from "@gl-shared/shared/ui";
// actions
import { employeesActionCreators } from "../../common/store/modules/employeesModule";

const Employees = props => {
  const navigate = useNavigate();
  const outletContext = useOutletContext();

  const addEmployeeForm = () => {
    window.scrollTo(0, 0);
    navigate(`/${hotelPanelRootUrl}/${pagesUrl.addEmployee}`);
  };

  const editEmployeeForm = selectedEmployee => {
    window.scrollTo(0, 0);
    props.setSelectedEmployeeAction(selectedEmployee);
    navigate(`/${hotelPanelRootUrl}/${pagesUrl.editEmployee}`);
  };

  useEffect(() => {
    // call employees initially (after we get hotel-info data) and on every hotel change
    if (props?.hotelData?.hotelUserId) {
      props.loadAllConcierges(props.selectedHotels[0]?.id);
      outletContext?.loadEmployees(props.selectedHotels[0]?.id);
    }
  }, [props.selectedHotels[0]?.id, props.hotelData]);

  return (
    <div className="employees component">
      {props.sectionLoadingNames === null || props.sectionLoadingNames?.includes(appSection?.employees) ? (
        <SectionLoader loadingLabel="LOADING EMPLOYEES" />
      ) : (
        <>
          {props.formData?.form === "AddEmployee" ||
          props.formData?.form === "EditEmployee" ||
          props.formData?.form === "DeleteEmployee" ? (
            <FormMessage
              form={props.formData?.form}
              formError={props.formData?.formError}
              formSuccessful={props.formData?.formSuccessful}
            />
          ) : null}
          {props.formData?.form === "HotelSelectionNotice" && (
            <FormMessage form={props.formData?.form} hotelName={props.formData?.hotelName} />
          )}
          <div className="row">
            <div className="col-lg-6">
              <div className="ibox ">
                <div className="ibox-title">
                  <h5>Employees</h5>
                  <CustomButton
                    isDisabled={false}
                    mainClass="btn-green"
                    customClasses="btn-green--height-l btn-green--auto-width"
                    onClick={() => {
                      addEmployeeForm();
                    }}
                    buttonText="ADD EMPLOYEE"
                  />
                </div>
                <div className="ibox-content">
                  <CustomTable
                    emptyTableMessage="No employees added yet"
                    customClasses="panel__table employees__table"
                    tableHead={[
                      { title: "Name", column: "first_name" },
                      { title: "Initials", column: "initials" },
                      { title: "Employee Number", column: "employee_number" }
                    ]}
                    tableItems={props?.employees}
                    tableButtonClick={item => editEmployeeForm(item)}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  employees: state.employees.employees,
  formData: state.global.formData,
  sectionLoadingNames: state.global.sectionLoadingNames,
  selectedHotels: state.global.selectedHotels,
  hotelData: state.home.hotelData
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setSelectedEmployeeAction: employeesActionCreators.setSelectedEmployeeAction,
      loadAllConcierges: employeesActionCreators.loadAllConciergesAction
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Employees);
